import { render, staticRenderFns } from "./SupplierUpdate.vue?vue&type=template&id=abf5c828&scoped=true"
import script from "./SupplierUpdate.vue?vue&type=script&lang=js"
export * from "./SupplierUpdate.vue?vue&type=script&lang=js"
import style0 from "./SupplierUpdate.vue?vue&type=style&index=0&id=abf5c828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf5c828",
  null
  
)

export default component.exports